/* eslint-disable */
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../Design_Asset_Actions.json";
import PROJECT_ACTION from "../Actions/projectKind.json";
import ApiSession from "../../../api/ApiSession";
import { getProjectTypeValue, getProject } from "../../../utils/project";
import { MGAAS_ANSI, MGAAS_ETO, NMGAAS_ETO, MGaaS_IEC } from "../../../utils/application.constants";

const apiSession = new ApiSession();
const FORCE_TRANSITION_UPDATE_KEY = "forceTransitionUpdatePending";

const useFetchAssetData = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
    allowedCbCount
  } = deps;

  // Cross-hook function aliases
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const getCBDetails = (...args) => fnRef.current.getCBDetails(...args);
  const assignComponents = (...args) => fnRef.current.assignComponents(...args);
  const addGenset = (...args) => fnRef.current.addGenset(...args);
  const addBattery = (...args) => fnRef.current.addBattery(...args);
  const checkSLDCount = (...args) => fnRef.current.checkSLDCount(...args);
  const setAlertMessage = (...args) => fnRef.current.setAlertMessage(...args);
  const filterHybridModel = (...args) => fnRef.current.filterHybridModel(...args);
  const removeGenset = (...args) => fnRef.current.removeGenset(...args);

  const loadToolTip = () => {
    setLoading(true);
    apiSession
      .getToolTip("information", "EN")
      .then((json) => {
        if(json){
          setCurrentProject(prev=>{
            return{
              ...prev,
              tooltipData: json
            }
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const getProjectDetailStatus = async() => {

    try {
      if (projectId) {
        const response = await apiSession.getProjectStatus(projectId);
          if (response) {
              setCurrentProject((prevData) => ({
                ...prevData,
                projectStatus: response,
              }));
            }
      }
    } catch (error) {
       if (error?.response?.status === 412) {
                callSnackbar("error", `${error?.message}`);  
              }
            }
    };  


  const getExternalID = async () => {
   try {
    await apiSession
    .getProjectExternalId()
    .then((response) => {
      setGsxExternalId((prevState) => ({
        ...prevState,
        utilityExternalId: response["1"],
        gensetExternalId: response["2"],
        pvAssetExternalId: response,
        batteryExternalId: response["3"],
      }));

      sessionStorage.setItem("externalId", JSON.stringify(response));
    })
    .catch((error) => {
       if (error?.response) {
          callSnackbar("error", `${error?.message}`);
        }
    });
   } catch (error) {
    console.log(error);
   }
  };
  const upDateCbcount = (components)=>{
    let count = 0;

    components.forEach(component => {       
        const uiAttributes = JSON.parse(component.uiAttributes);
        if (component.componentType === "Circuit Breaker" && uiAttributes.cbRequired ) {
            count += 1;
        }
    });

    setCbCount(prev=>({
      ...prev,
      assetCbCount: count <=allowedCbCount?count:allowedCbCount ,
    }));
  }
  const fetchDefaultDataValues =() => {
    setLoading(true);   
    try {
      apiSession
      .getAssetDefaultValues(projectId)
      .then(async (json) => {
         projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_DEFAULT_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        setSpanishCodeRealTime(json?.gridSettings?.spanishCodeRealTime);
        setAssetDefaultValues(json.defaultValues);
        setDefaultComponentData((prevData) => {
          return {
          ...prevData,
          defaultComponentData: json?.hybrid,
        }});
        if(json?.hybrid){
          setBatterySystemA2EConfig(prev=>{
            const hybridModels = json?.hybrid?.assetAttributes.find(
              (assetType) => assetType.type === "hybridModels"
            )?.value.split(",");
            const {storageCapacity, timeCapacity} = filterHybridModel(json?.hybrid?.assetAttributes, hybridModels?.[0]);
            
            setConfigData((prevState) => ({
              ...prevState,
              configData:{ 
                ...prevState.configData,
                hybridModels:hybridModels,
                namePlateEnergy:storageCapacity,
                time_capacity:timeCapacity
                },
            }));
            sessionStorage.setItem("bessData",JSON.stringify({hybridModels,storageCapacity, timeCapacity}));
            return {
              ...prev,
              model:hybridModels,
              namePlateEnergy:storageCapacity,
            }
          });
         
        }
       
       setClientType(json?.clientType);
        assignDefaultValues(
          json.defaultValues,
          json.gridSettings,
          json.defaults,
          json.siteType,
          json.switchboardType,
          json.genset,
          json.powerMeter,
          json.architecture,
          json.clientType,
          json.pm_Utility,
          json.pm_Genset,
          json.pm_PV,
          json.nominalVoltage,
          json.bess,
          json.hybrid,
          json.cb,
          json.pm_Bess,
          json.contactor,
          json.dummyCB,
          json.ev,
          json.pm_EV,
          json.remoteMain,
          json.cb_Load,
          json.cb_Utility,
          json.gridSettings?.exportOptimization,
          json?.gt,
        );
      })
      .catch(() => callSnackbar("error", embLabels.errorInLoadingData));
    } catch (error) {
      console.log(error)
    }
  };

  const assignDefaultValues = (
    defaultValues,
    gridSettings,
    defaults,
    type,
    switchboardType,
    genset,
    powerMeter,
    architecture,
    clientType,
    pmUtility,
    pmGenset,
    pmPv,
    nominalVoltage,
    bess,
    hybrid,
    cb,
    pmBess,
    contactor,
    dummyCB,
    ev,
    pmEV,
    remoteMain,
    cb_Load,
    cb_Utility,
    isExportOptimization,
    gt
  ) => {
    
    const dataPreFill = [];
    dataPreFill[0] = defaultValues;
    dataPreFill[1] = gridSettings;
    dataPreFill[2] = defaults;
    dataPreFill[3] = contactor;
    setCBLoadData(cb_Load);
    setDefaultPreFillData(dataPreFill);
    CBAssetListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        defaults,
        type,
        architecture,
        genset,
        defaults,
        pmUtility,
        pmGenset,
        pmPv,
        bess,
        hybrid,
        cb,
        pmBess,
        gridSettings,
        powerMeter,
        contactor,
        clientType,
        mode: defaultPreFillData[1]?.mode,
        cb_Utility,
        projectTypeValue: projectTypeValue,
        isEvce,
      },
    });
    setDefaultCbData({ ...cb });
    setDefaultPmData({ ...powerMeter });
    setDefaultDummyCbData({ ...dummyCB });
    setEVContactorData({...contactor});
    setGTContractorData({...contactor});
    setGensetAssetData({...genset});
    setEVPMData({...pmEV})
    setEVDefaultData({...ev});
    setGTDefaultData({...gt})
    setBatteryCommunicationData({
      ipaddress: defaultValues.BESS.ipAddress,
      subnetmask: defaultValues.BESS.subnetMask,
      defaultGateway: defaultValues.BESS.defaultGateway,
      modbusSlaveId: defaultValues.BESS.modbusId,
    });
    if ([embLabels.PV_HYBRIDIZATION, embLabels.GRID_CONNECTED, embLabels.ISLANDABLE, embLabels.OFF_GRID].includes(type)) {
      setPowerMeter({
        assetAttributes: powerMeter.assetAttributes,
        assetEnabled: powerMeter.assetEnabled,
        assetId: powerMeter.assetId,
        assetInfo: powerMeter.assetInfo,
        assetProperties: powerMeter.assetProperties,
        assetType: powerMeter.assetType,
        comments: powerMeter.comments,
        communicationModel: powerMeter.communicationModel,
        imageLink: powerMeter.imageLink,
        manufacturer: powerMeter.manufacturer,
      });
    }
    CBEVListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        cb,
        contactor:contactor,
        ev,
        pmEV,
        isEvce,
      },
    });
    CBGTListDispatch({
      type:ACTIONS.ASSIGN_DEFAULT_GT_VALUES
    });
    setEvCommunicationData({
      ipaddress: defaultValues.EV_charging_station.ipAddress,
      subnetmask: defaultValues.EV_charging_station.subnetMask,
      defaultGateway: defaultValues.EV_charging_station.defaultGateway,
      modbusSlaveId: defaultValues.EV_charging_station.modbusId,
    });
    CBLoadListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        type,
        defaults,
        cb,
        dummyCB,
        pmAssetData: powerMeter,
        contactor: contactor,
        cb_Load,
        projectTypeValue,
        isEvce,
        isExportOptimization
      },
    });

    PVDetailsDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        gsxExternalId,
        isEvce
      },
    });

    setCommunicationState({
      ...communicationState,
      ifeIpAddress1: defaultValues["Circuit Breaker"].ipAddress1,
      ifeIpAddress2: defaultValues["Circuit Breaker"].ipAddress2,
      ifeIpAddress3: defaultValues["Circuit Breaker"].ipAddress3,
      ifeIpAddress4: defaultValues["Circuit Breaker"].ipAddress4,
      ifeIpAddress5: defaultValues["Circuit Breaker"].ipAddress5,
      ifeIpAddress6: defaultValues["Circuit Breaker"].ipAddress6,
      ifeIpAddress7: defaultValues["Circuit Breaker"].ipAddress7,
      ifeIpAddress8: defaultValues["Circuit Breaker"].ipAddress8,
      ifeIpAddress9: defaultValues["Circuit Breaker"].ipAddress9,
      ifeIpAddress10: defaultValues["Circuit Breaker"].ipAddress10,
      ifeIpAddress11: defaultValues["Circuit Breaker"].ipAddress11,
      ifeIpAddress12: defaultValues["Circuit Breaker"].ipAddress12,
      ifeIpAddress13: defaultValues["Circuit Breaker"].ipAddress13,
      ifeIpAddress14: defaultValues["Circuit Breaker"].ipAddress14,
      ifeIpAddress15: defaultValues["Circuit Breaker"].ipAddress15,
      ifeIpAddress16: defaultValues["Circuit Breaker"].ipAddress16,
      ifeIpAddress17: defaultValues["Circuit Breaker"].ipAddress17,
      ifeIpAddress18: defaultValues["Circuit Breaker"].ipAddress18,
      ifeIpAddress19: defaultValues["Circuit Breaker"].ipAddress19,
      ifeIpAddress20: defaultValues["Circuit Breaker"].ipAddress20,
      ifeIpAddress21: defaultValues["Circuit Breaker"].ipAddress21,
      ifeIpAddress22: defaultValues["Circuit Breaker"].ipAddress22,
      ifeIpAddress23: defaultValues["Circuit Breaker"].ipAddress23,
      ifeIpAddress24: defaultValues["Circuit Breaker"].ipAddress24,
      ifeSubnetMask: defaultValues["Circuit Breaker"].subnetMask,
      ifeSubnetMask2: defaultValues["Circuit Breaker"].subnetMask2,
      ifeSubnetMask3: defaultValues["Circuit Breaker"].subnetMask3,
      ifeSubnetMask4: defaultValues["Circuit Breaker"].subnetMask4,
      ifeGateway: defaultValues["Circuit Breaker"].defaultGateway,
      ifeGateway2: defaultValues["Circuit Breaker"].defaultGateway2,
      ifeGateway3: defaultValues["Circuit Breaker"].defaultGateway3,
      ifeGateway4: defaultValues["Circuit Breaker"].defaultGateway4,
    });

    const allIps = [];
    for (let i = 0; i < allowedCbCount; i++) {
      const value = `ipAddress${i + 1}`;
      allIps.push(defaultValues["Circuit Breaker"][value]);
    }
    setCbCommunicationValues((prevState) => ({
      ...prevState,
      allIps,
      availableIps: allIps,
    }));

    setNominalVoltage(nominalVoltage);

    const defaultsData = {};

    for (let defaultData of defaults) {
      defaultsData[defaultData["param"]] = defaultData["value"];
    }
   let isBoostPro = bess?.assetAttributes?.filter(
    (item) => item?.type === "isBoostPro"
  )[0]?.value;
  isBoostPro =
    typeof isBoostPro === "string" ? JSON.parse(isBoostPro) : false;

    if(isBoostPro){
       setDefaultsMinMax( prev =>{
      // based logic on program page, refer getProgramData function
      if(defaultsData.socEmergencyDefault !== undefined && defaultsData.socEssentialDefault !== undefined){
    defaultsData.socEmergencyDefault  = Number(defaultsData.socEmergencyDefault) ;
    defaultsData.socEssentialDefault =  Number( defaultsData.socEssentialDefault);
    defaultsData.SoC_min_optimization =  Number( defaultsData.socMinOptimizationDefault);
    defaultsData.socMinMin = Number(defaultsData.socMinEstar);
    defaultsData.socMinMax = Number(defaultsData.socMaxEstar);
    // 0
// bess?.assetAttributes?.filter((item) => item?.type === "soc_min")[0]?.value;
      }
      return  defaultsData
      }
    );
    }else{
      setDefaultsMinMax( prev =>{
      // based logic on program page, refer getProgramData function
      if(defaultsData.socEmergencyDefault !== undefined && defaultsData.socEssentialDefault !== undefined){
    defaultsData.socEmergencyDefault  = Number(defaultsData.socEmergencyDefault) ;
    defaultsData.socEssentialDefault =  Number( defaultsData.socEssentialDefault);
    defaultsData.SoC_min_optimization =  Number( defaultsData.socMinOptimizationDefault);
      }
      return  defaultsData
      }
    );
    }
   
    fetchComponentsExisted(defaultValues, contactor, dummyCB, cb, bess, defaults, gridSettings);
    setSiteType(type);
    setSwitchboardType(switchboardType);
    setRemoteMain(remoteMain);
    // setClientType(clientType);
    setArchitectureType(architecture);
  };
  //fetch the all component list step 3
  const fetchComponentsExisted = (defaultValues,contactor,dummyCB,cb, bess, defaults, gridSettings) => {
    apiSession
      .getComponents(projectId)
      .then((data) => {
        const json = data;
        setJsonData(json.components);
        upDateCbcount(json.components);
         projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        try {
            setUpdateComponents(prev=>{
              return {
          ...prev,
          updateComponents:json.components
        }})
        } catch (error) {
          //nothing doing here
        }
        setGridTransitionOnline(json?.gridTransitionOnline);
        if(json){
          setIsAntiIslandingRelayEnable(json?.antiIslandingDetection);
          setIsSelectSpanishCode(json?.isSpanishCodeRealTime);
        }
        if(json?.components?.length > 0){
          const isBessAvailable = json?.components?.find(item=> item["componentName"] === "BESS");
          if(isBessAvailable){
            try {
              const bessConfigData = JSON.parse(isBessAvailable?.attributes);
              if(bessConfigData?.soc_emergency && bessConfigData?.soc_essential){
                setDefaultsMinMax(prev=>{
                  return {
                    ...prev,
                    socEmergencyDefault:bessConfigData?.soc_emergency,
                    socEssentialDefault:bessConfigData?.soc_essential
                  }
        
                });
              
                setBessControllerPrevValue({
                  max_power:Number(bessConfigData?.max_power),
                  capacity:Number(bessConfigData?.capacity),
                  quantityOfBess:Number(bessConfigData?.quantityOfBess),
                })
              }
            } catch (error) {
              callSnackbar("error", "Bess data is not available");
            }
           
          }         
         
        }
        // projectKindDispatch({
        //   type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
        //   payload: { ...json, projectTypeValue },
        // });
        ComponentDataDispatch({
          type: ACTIONS.UPDATE_COMPONENT_DATA,
          payload: json,
        })
        sessionStorage.setItem("programPage", json?.programPage);
        sessionStorage.setItem("communicationValidated", json?.systemsPage);
        setSiteCreated(json?.siteCreated);
        setUpdateComponents(prev=>({
          ...prev,
          isSiteCreated:json?.siteCreated
        }))
        setSwitchboardType(json?.switchboardType);
        setIsEvce(json?.isElectricalVehicleEnergyManagement)
        
        setRemoteMain(json?.remoteMain);
        setSiteType(json?.siteType);
        setEvceDiagramChangeRequired(json?.evceDiagramChangeRequired);
        setIsAllowMultipleLoads(json?.isAllowMultipleLoads);
        setIsExportOptimization(json?.isExportOptimization);
        if (
          (json?.components.length > 0 && json?.siteType === "GENSET_PVBESS_A2E") 
        ) {
           const bessConfigData = JSON.parse(sessionStorage.getItem("bessData"));
             const storageObj = {};
             bessConfigData?.storageCapacity.forEach((value, index) => {
                                storageObj[index] = value;
                              })
          const configData = JSON.parse(
              json?.components?.filter((item) =>
                ["Hybrid", "BESS"].includes(item["componentType"])
              )[0].attributes
            );
          // const hybridModels = configData?.hybridModels?(JSON.parse(configData?.hybridModels)):(bessConfigData?.hybridModels);
          const timeCapacity =  configData?.time_capacity?Object.keys(JSON.parse(configData?.time_capacity)):Object.values(storageObj);
          setBatterySystemA2EConfig(prev=>{
            return {
              ...prev,
              // model:[...hybridModels],
             namePlateEnergy:[...timeCapacity],
            }
          });
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_EXISTING_BATTERY_CONFIG,
            payload: {
              index: 7,
              data:configData,
            },
          });
        }
        if (
          json?.components.length > 0 &&
          json?.diagramChangeRequired === false
        ) {
           setFirstTimecall(false);
          getCBDetails(json?.components);
          assignComponents(json, contactor,json?.isAllowMultipleLoads,json?.isExportOptimization);
          setMultipleLoads(json?.isAllowMultipleLoads)
          const defaultConfigurationStatusNew =false;
          fetchUseCase(
            defaultConfigurationStatusNew,
            defaultValues,
            json.siteType,
            json.diagramChangeRequired,
             json.isAllowMultipleLoads,
            dummyCB,
            cb,
            json.isExportOptimization,
            projectTypeValue,
            json.bessTransitionChangeRequest,
            defaults,
            bess,
            json?.gridTransitionOnline
          );

          setLoadSide(json?.connectionType);
         
          
        } else {
          const defaultConfigurationStatusNew = true;
          setFirstTimecall(true);
          setMultipleLoads(json?.isAllowMultipleLoads)
          setDefaultConfigurationStatus(defaultConfigurationStatusNew);
          fetchUseCase(
            defaultConfigurationStatusNew,
            defaultValues,
            json.siteType,
            json.diagramChangeRequired,
            json.isAllowMultipleLoads,
             dummyCB,
              cb,
            json.isExportOptimization,
            projectTypeValue,
            json.bessTransitionChangeRequest,
            defaults,
            bess,
             
          );
        
        }
       if( json?.components.length > 0 &&
          json?.evceDiagramChangeRequired  ){
          //  CBEVListDispatch({
          //   type: ACTIONS.REMOVE_ASSET_EV,
          //   payload: {
          //     index: 0,
          //     configData,
          //   },
          // });
          CBEVListDispatch({
              type: ACTIONS.REMOVE_ASSET_EV_CHANGED,
              payload: {
              index: 0,
              configData,
            },
            });
          setDetailsBlock((prevState) => ({
            ...prevState,
            evDetailsBlock: false,
          }));

            countDispatch({
              type: ACTIONS.RESET_EV_COUNT,
              payload: { count: 0 },
            });
             const runCalculateCoordinatesNew = { componentPush: true };
           const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          setTimeout(() => {
          setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

            setRunCalculateCoordinates(runCalculateCoordinatesNew);
            // setLoading(false);
          }, 1000);
          }
       if(json?.gridTransitionOnline !== "OPEN" || gridSettings.mode === "FUEL_SAVER" || gridSettings.mode === "GENSET_MAIN_NO_BESS"){
              CBGTListDispatch({
                type: ACTIONS.REMOVE_GT,
                payload: {
                  index: 0,
                },
              });
              setDetailsBlock((prevState) => ({
                ...prevState,
                gtDetailsBlock: false,
              }));

              countDispatch({
                type: ACTIONS.UPDATE_GT_COUNT,
                payload: { count: 0 },
              });
              
              const runCalculateCoordinatesNew = { componentPush: true };

              setTimeout(() => {
                setRunCalculateCoordinates(runCalculateCoordinatesNew);
              }, 500);
              setTimeout(() => {
                setFirstTimecall(true);
              }, 1000);
        }
        
      })
      .catch(() => {
        setLoading(false);
        setSldLoadCompleted(false);
        callSnackbar("error", embLabels.errorInLoadingData);
      });
  };
  const fetchUseCase = (
    defaultConfigurationStatusNew,
    defaultValues,
    siteType,
    diagramChangeRequired,
    isAllowMultipleLoads,
    dummyCB,
    cb,
    isExportOptimization,
    projectTypeValue,
    bessTransitionChangeRequest,
    defaults,
    bess,
    transitionType,
  ) => {
    apiSession
      .fetchUseCase(projectId)
      .then((json) => {
        setSldLoadCompleted(true);
        setUseCases(json);
        if (defaultConfigurationStatusNew) {
          loadUseCase(
            json,
            defaultConfigurationStatusNew,
            defaultValues,
            siteType,
            diagramChangeRequired,
             isAllowMultipleLoads,
             dummyCB,
              cb,
            isExportOptimization,
            bessTransitionChangeRequest,
            bess,
            defaults
          );
          
        } else {
          setLoading(true);
          setAvailableDer(json);
          const tempProjectTypeValue1 = getProjectTypeValue()
        if((tempProjectTypeValue1 === MGAAS_ANSI ||  tempProjectTypeValue1 === MGAAS_ETO  || tempProjectTypeValue1 === NMGAAS_ETO || tempProjectTypeValue1 === MGaaS_IEC) && CBLoadList.length >0 && siteType === "GRID_CONNECTED" && (isAllowMultipleLoads || diagramChangeRequired)){
          CBLoadListDispatch({
            type: ACTIONS.REMOVE_ASSET_LOADS,
            payload: {
              dummyCB:dummyCB ||[],
              cb:cb ||[],
              isAllowMultipleLoads:isAllowMultipleLoads || false,
              isExportOptimization:isExportOptimization || false,
               projectTypeValue:projectTypeValue || "",
              siteType:siteType || "",
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT_ONLY_ONE,
            payload: { count: 1 },
          });
            setLoading(false);
         }
        if(bessTransitionChangeRequest){
            setLoading(true);
          sessionStorage.setItem(FORCE_TRANSITION_UPDATE_KEY, "true");
           CBAssetListDispatch({
            type: ACTIONS.UPDATE_BESS_TRANSITION,
            payload: { defaultValues, projectTypeValue, bess, defaults },
          });
            const runCalculateCoordinatesNew = { componentPush: true };
           const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          // coordinates must commit first, otherwise the payload is built from the pre-coordinate lists
          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 600);
          setTimeout(() => {
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
            setLoading(false);
          }, 1000);
        }
        if(isAllowMultipleLoads){
          setLoading(true);
            const runCalculateCoordinatesNew = { componentPush: true };
             const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          setTimeout(() => {
           setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

            setRunCalculateCoordinates(runCalculateCoordinatesNew);
            setLoading(false);
          }, 1000);
        
          }
          checkUseCase(json);
        }
         setLoading(true);
          setTimeout(() => {
            setLoading(false);
          }, 2000);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadUseCase = (
    usecase,
    defaultConfigurationStatusNew,
    defaultValues,
    siteType,
    diagramChangeRequired,
    isAllowMultipleLoads,
     dummyCB,
    cb,
    isExportOptimization,
    bessTransitionChangeRequest,
    bess,
    defaults
  ) => {
    const usecaseList = Array.isArray(usecase) ? [...usecase] : [];
    const isEtoHybridFlow =
      siteType === embLabels.PV_HYBRIDIZATION &&
      (projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO");

    if (isEtoHybridFlow) {
      if (!usecaseList.includes(embLabels.UTILITY)) usecaseList.push(embLabels.UTILITY);
      if (!usecaseList.includes(embLabels.PV_INVERTER)) usecaseList.push(embLabels.PV_INVERTER);
      if (!usecaseList.includes(embLabels.LOAD)) usecaseList.push(embLabels.LOAD);
    }

    usecaseList.forEach((usecaseData) => {
      switch (usecaseData) {
        case embLabels.UTILITY:
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_UTILITY,
            payload: { defaultValues, projectTypeValue,siteType },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.GENERATOR:
          const projectTypeA2E = projectTypeValue ?? getProject()?.projectType
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_GENSET,
            payload: { defaultValues, projectTypeA2E, siteType },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          setUseCaseValidGenset(true);
          break;

        case embLabels.BESS:
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_BESS,
            payload: { defaultValues, projectTypeValue, siteType },
          });
          break;

        case embLabels.PV_INVERTER:
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_PV,
            payload: { defaultValues, projectTypeValue, siteType },
          });

          //* assign pv to pvset1

          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));

          PVDetailsDispatch({
            type: ACTIONS.ASSIGN_USECASE_PVSET1,
            payload: {
              count: 3,
              externalIds: externalIds,
              projectTypeValue: projectTypeValue
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          break;

        case embLabels.HYBRID:
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_HYBRID,
            payload: { defaultValues, projectTypeValue, siteType },
          });
          break;

        case embLabels.LOAD:
          CBLoadListDispatch({
            type: ACTIONS.ASSIGN_USECASE_LOAD,
            payload: {
              defaultValues,
              defaultCbData,
              siteType,
              defaultDummyCbData,
              projectTypeValue
            },
          });
          const tempProjectTypeValue = getProjectTypeValue()
        if((tempProjectTypeValue === MGAAS_ANSI ||  tempProjectTypeValue === MGAAS_ETO  || tempProjectTypeValue === NMGAAS_ETO || tempProjectTypeValue === MGaaS_IEC) && CBLoadList.length >0 && siteType === "GRID_CONNECTED" && (isAllowMultipleLoads || diagramChangeRequired)){ 
          CBLoadListDispatch({
            type: ACTIONS.REMOVE_ASSET_LOADS,
             payload: {
              dummyCB:dummyCB ||[],
              cb:cb ||[],
              isAllowMultipleLoads:isAllowMultipleLoads || false,
              isExportOptimization:isExportOptimization || false,
               projectTypeValue:projectTypeValue || "",
              siteType:siteType || "",
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT_ONLY_ONE,
            payload: { count: 1 },
          });
         }else
          {
           countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT,
            payload: { count: 1 },
          });

         }
         
          break;
         
        default:
          break;
      }
    });
        if(bessTransitionChangeRequest){
            setLoading(true);
          sessionStorage.setItem(FORCE_TRANSITION_UPDATE_KEY, "true");
           CBAssetListDispatch({
            type: ACTIONS.UPDATE_BESS_TRANSITION,
            payload: { defaultValues, projectTypeValue, bess, defaults },
          });
            const runCalculateCoordinatesNew = { componentPush: true };
           const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          // coordinates must commit first, otherwise the payload is built from the pre-coordinate lists
          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 600);
          setTimeout(() => {
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
            setLoading(false);
          }, 1000);
        }
    if (defaultConfigurationStatusNew) {
      const runCalculateCoordinatesNew = { componentPush: true };
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    } else {
      const runCalculateCoordinatesNew = { componentPush: false };
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }

    setLoading(false);
  };
  const checkUseCaseChangeByUser = () => {
    const foundGenerator = availableDer.indexOf(embLabels.GENERATOR);
    const foundBESS = availableDer.indexOf(embLabels.BESS);

    if (foundGenerator === -1 &&( siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID)) {
      if (CBAssetList[1].uiData.status) {
        removeGenset();
      }
    } else if (foundGenerator !== -1) {
      if (
        !CBAssetList[1].uiData.status &&
        sessionStorage.getItem("useCaseChanged") === "true"
      ) {
        checkGensetDeleteOneDER(true);
      }
    }

    if (foundBESS !== -1) {
      if (
        !CBAssetList[2].uiData.status &&
        sessionStorage.getItem("useCaseChanged") === "true"
      ) {
        if (checkSLDCount()) {
          setLoading(true);
          setTimeout(() => {
            if (UserScope.access.saveSLD === true) {
              if (siteType === embLabels.ISLANDABLE ||  siteType === embLabels.OFF_GRID) {
                addBattery();
              }
            }
            setLoading(false);
          }, 800);
        } else {
          setAlertMessage(`Alert`, false, ``, embLabels.deleteOneDERToAddGeset);
        }
      }
    }
    sessionStorage.setItem("useCaseChanged", false);
  };

  const checkGensetDeleteOneDER = (existedInUsecase) => {
    if (existedInUsecase) {
      if (checkSLDCount()) {
        setDeleteOneDER(false);
        setLoading(false);
        setTimeout(() => {
          if (siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) {
            addGenset();
          }
        }, 800);
      } else {
        setAlertMessage(`Alert`, false, ``, embLabels.deleteOneDERToAddGeset);
        sessionStorage.setItem("deploymentReady", false);
         setDeploymentReady("false");
        setDeleteOneDER(true);
      }
    }
  };

  const checkUseCase = (usecase) => {
    const hasGenerator = usecase.includes(embLabels.GENERATOR);
    if (hasGenerator) setUseCaseValidGenset(true);
  };


  return {
    loadToolTip,
    getProjectDetailStatus,
    getExternalID,
    upDateCbcount,
    fetchDefaultDataValues,
    checkUseCaseChangeByUser,
    checkGensetDeleteOneDER,
    checkUseCase,
  };
};

export default useFetchAssetData;